import React from 'react';

type Props = {
  className?: string;
  image_placement: 'left' | 'right';
  question: string;
  answer: React.ReactNode;
  image_url: string;
  svg_path: string;
  svg_bg_color: string;
  svg_path_color: string;
};

export const PDFQuestions: React.FC<Props> = ({
  className,
  image_placement,
  image_url,
  answer,
  question,
  svg_path,
  svg_bg_color,
  svg_path_color,
}) => {
  return (
    <>
      <div className={`${className}`}>
        <div
          className={
            'grid grid-cols-1 md:grid-cols-2 md:gap-x-10 md:items-center'
          }
        >
          <div
            className={`mx-10   ${
              image_placement === 'right'
                ? ' md:mx-0 lg:mr-6 xl:mr-14'
                : ' md:mx-0 lg:ml-6 xl:ml-14'
            }  mt-10 md:mt-0 text-gray-900 text-left ${
              image_placement === 'right'
                ? 'md:col-start-1 md:row-start-1 row-start-2 '
                : 'md:col-start-2 md:row-start-1 row-start-2'
            }`}
          >
            <p className="text-2xl mx-auto tracking-tight font-bold text-left  sm:text-4xl md:text-4xl">
              <span className="block text-gray-900">{question}</span>
            </p>
            <p className="text-base mx-auto  sm:text-xl text-left md:text-lg text-gray-900 mt-4">
              {answer}
            </p>
          </div>
          <div
            className={`${svg_bg_color} w-4/5 sm:w-3/4 md:w-full mx-auto  rounded-xl shadow-md ${
              image_placement == 'right'
                ? 'md:col-start-2 row-start-1'
                : 'md:col-start-1 row-start-1 justify-items-start'
            }`}
          >
            <div className={'lg:p-10 2xl:p-16 md:p-6 p-16 mx-auto '}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className={svg_path_color}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={0.5}
                  d={svg_path}
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
